import * as React from "react"

const ArrowUpRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M6.7 5h-.5v1h3.5l-5 4.6-.4.4.7.7.3-.3 5.1-4.8v3.6h1V4.9H6.7Z" />
  </svg>
)

export default ArrowUpRight
